// removed by extract-text-webpack-plugin
module.exports = {"list":"ydWp9w2ReNXYE6tkCPJIL","bottomContainer":"_2MxQWDCSmoTzNgs9PZJU5L","buttonContainer":"_2x1dpopLzurYBXDhE7iMF9"};


//////////////////
// WEBPACK FOOTER
// ./src/components/SongsSelectPopup/SongsSelectPopup.scss
// module id = 627
// module chunks = 1